export const fullShortFormat = (date: Date, locale?: Intl.LocalesArgument): string => {
  try {
    return date.toLocaleDateString(locale).replace(/\//g, "-");
  } catch (error) {
    return error.message;
  }
};
